import { Pipe, PipeTransform } from '@angular/core';
import { MeterDataStoreServiceDirective } from '@app/shared/services/store/meter-data-store.service';

@Pipe({
  name: 'getEnergyTypeImage',
})
export class GetEnergyTypeImagePipe implements PipeTransform {
  constructor(private meterDataStoreServiceDirective: MeterDataStoreServiceDirective) {}

  transform(value: any) {
    return this.meterDataStoreServiceDirective.getEnergyTypeImage(value);
  }
}
